import { ContentModulePageModule, ContentModule } from './ContentModule';
import { ModuleOfType, ModuleType } from './ModuleType';

type ContainerModuleProps = {
  id: string;
  modules: ContentModulePageModule | Array<ContentModulePageModule>;
  renderCondition: boolean;
};

type ContainerPageModule = ModuleOfType<
  ModuleType.Container,
  ContainerModuleProps
>;

const ContainerModule = ({
  modules,
  renderCondition,
}: ContainerModuleProps) => {
  const mods = Array.isArray(modules) ? modules : [modules];

  return renderCondition ? (
    <>
      {mods.map(module => (
        <ContentModule {...module} key={module.key} />
      ))}
    </>
  ) : null;
};

export { ContainerModule };
export type { ContainerPageModule, ContainerModuleProps };
